
import { mapState } from 'vuex';
import addressMixin from '@/mixins/addressMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import { CollapseTransition, Checkbox } from 'element-ui';
export default {
  mixins: [addressMixin, cartMixin],
  name: 'CheckoutAddressInvoice',
  data() {
    return {
      showForm: false,
      isAddingAddress: false,
      changeAddress: false,
      updating: false,
    };
  },
  computed: {
    ...mapState('checkout', [
      'shippingAddress',
      'invoiceAddress',
      'sameAsDelivery',
      'checkoutError',
    ]),
    sameAsDeliveryLocal: {
      get() {
        return !this.sameAsDelivery;
      },
      set(val) {
        this.$store.commit('checkout/setSameAsDelivery', { data: !val });
      },
    },
  },
  methods: {
    toggleForm() {
      this.showForm = !this.showForm;
      if (this.showForm) this.isAddingAddress = true;
    },
    selectAddress(address) {
      this.updating = true;
      this.addressService
        .updateAddressType({
          idAddress: address.IdAddress,
          isInvoice: true,
          isDelivery: address.IsDelivery,
        })
        .then(() => {
          this.addressService.fetchAddresses();
          this.changeAddress = false;
        })
        .finally(() => {
          this.updating = false;
        });
    },
    onAddressFilled(address) {
      if (!this.sameAsDelivery && address && (address.Address1 || address.Postcode)) {
        this.$store.commit('checkout/setInvoiceAddress', {
          data: { ...address },
        });
      }
    },
    syncInvoice() {
      const source = this.sameAsDelivery
        ? this.shippingAddress
        : this.getAddressInvoice;
      if (source) {
        this.$store.commit('checkout/setInvoiceAddress', {
          data: { ...source },
        });
      }
    },
  },
  watch: {
    sameAsDelivery: {
      handler() {
        this.syncInvoice();
      },
      immediate: true,
    },
    shippingAddress: {
      handler() {
        if (this.sameAsDelivery) this.syncInvoice();
      },
      deep: true,
    },
    getAddressInvoice: {
      handler(val) {
        if (!val) return;
        if (!this.sameAsDelivery) this.syncInvoice();
      },
      deep: true,
      immediate: true,
    },
    checkoutError: {
      handler(val) {
        if (
          val &&
          !this.showForm &&
          !this.sameAsDelivery &&
          this.invoiceAddress
        ) {
          const requiredFields = [
            'Firstname',
            'Lastname',
            'Address1',
            'Postcode',
            'City',
            'CountryIsoCode',
            'MobilePhone',
          ];
          const isMissing = requiredFields.some(
            (f) =>
              !this.invoiceAddress[f] ||
              !this.invoiceAddress[f].toString().trim()
          );
          if (isMissing) {
            this.showForm = true;
            this.isAddingAddress = false;
          }
        }
      },
    },
  },
  mounted() {
    if (this.idAddressDelivery !== this.idAddressInvoice) {
      this.$store.commit('checkout/setSameAsDelivery', { data: false });
    }
  },
  components: {
    CollapseTransition,
    Checkbox,
  },
};
